import React from 'react'
import { Footer } from 'flowbite-react/lib/esm/components';

function LandingFooter() {
    return (
        <div className='bg-slate-100 text-center md:px-10 md:pb-4'>
            <Footer container={true}>
                <Footer.Copyright
                    href="/"
                    by=" Seekr"
                    year={2022}
                />
                <Footer.LinkGroup>
                    <div className='flex mt-5 justify-center w-full sm:mt-auto gap-x-3 md:gap-x-0 flex-row'>
                        <Footer.Link href="/">
                            About
                        </Footer.Link>
                        <Footer.Link href="/">
                            FAQ
                        </Footer.Link>
                        <Footer.Link href="/">
                            Support
                        </Footer.Link>
                        <Footer.Link href="/">
                            Contact
                        </Footer.Link>
                    </div>
                </Footer.LinkGroup>
            </Footer>
        </div>
    );
}

export default LandingFooter;